import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Project from '../components/Project';
import {
  loadUsers,
  updateAssignedUser
} from "../../lineItems/actions";
import {
  loadProject,
  reset,
  loadSurveyQaInfo,
  saveSurveyQa,
  getAttributesDetails,
  loadLineitemsByProjectId,
  loadSurveyQuestionnaire,
  loadHistory
} from "../actions";

function mapDispatchToProps(dispatch) {
  const actions = {
    loadProject,
    loadSurveyQaInfo,
    saveSurveyQa,
    loadLineitemsByProjectId,
    loadHistory,
    reset,
    loadUsers,
    updateAssignedUser,
    getAttributesDetails,
    loadSurveyQuestionnaire
  }

  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

function mapStateToProps (state) {
  const { project, lineitems } = state;
  return { ...project, lineitems };
}


export default connect(mapStateToProps, mapDispatchToProps)(Project)